<h2 mat-dialog-title>{{ dialogTitle() }}</h2>
<mat-dialog-content>
    @if (isLoading()) {
        <mat-spinner [diameter]="32" />
    } @else {
        <form [formGroup]="formGroup">
            <div class="row">
                <div class="col-3">
                    <sl-input type="text" placeholderKey="AgendaItemSettings.Number" [control]="formGroup.controls.number" />
                </div>
                <div class="col-4 offset-md-5 checkbox-wrapper">
                    <mat-checkbox [formControl]="formGroup.controls.showOnNetvote">
                        {{ 'AgendaItemSettings.ShowOnNetvote' | translate }}
                    </mat-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <sl-input
                        type="number"
                        placeholderKey="AgendaItemSettings.CouponNo"
                        [control]="formGroup.controls.votingCouponNumber" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="text">
                        <mat-label>{{ 'General.Description' | translate }} DE</mat-label>
                        <textarea
                            matInput
                            [formControl]="formGroup.controls.descriptionGerman"
                            [errorStateMatcher]="descriptionErrorStateMatcher()"></textarea>
                        <mat-error>
                            {{ 'GeneralMeeting.AtLeastOneDescriptionRequired' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>{{ 'AgendaItemSettings.DescriptionVoting' | translate }} DE</mat-label>
                        <input matInput [formControl]="formGroup.controls.descriptionVotingGerman" />
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="text">
                        <mat-label>{{ 'General.Description' | translate }} FR</mat-label>
                        <textarea
                            matInput
                            [formControl]="formGroup.controls.descriptionFrench"
                            [errorStateMatcher]="descriptionErrorStateMatcher()"></textarea>
                        <mat-error>
                            {{ 'GeneralMeeting.AtLeastOneDescriptionRequired' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>{{ 'AgendaItemSettings.DescriptionVoting' | translate }} FR</mat-label>
                        <input matInput [formControl]="formGroup.controls.descriptionVotingFrench" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="text">
                        <mat-label>{{ 'General.Description' | translate }} EN</mat-label>
                        <textarea
                            matInput
                            [formControl]="formGroup.controls.descriptionEnglish"
                            [errorStateMatcher]="descriptionErrorStateMatcher()"></textarea>
                        <mat-error>
                            {{ 'GeneralMeeting.AtLeastOneDescriptionRequired' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>{{ 'AgendaItemSettings.DescriptionVoting' | translate }} EN</mat-label>
                        <input matInput [formControl]="formGroup.controls.descriptionVotingEnglish" />
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="text">
                        <mat-label>{{ 'General.Description' | translate }} IT</mat-label>
                        <textarea
                            matInput
                            [formControl]="formGroup.controls.descriptionItalian"
                            [errorStateMatcher]="descriptionErrorStateMatcher()"></textarea>
                        <mat-error>
                            {{ 'GeneralMeeting.AtLeastOneDescriptionRequired' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <mat-label>{{ 'AgendaItemSettings.DescriptionVoting' | translate }} IT</mat-label>
                        <input matInput [formControl]="formGroup.controls.descriptionVotingItalian" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <fieldset>
                        <legend>{{ 'AgendaItemSettings.VoteType' | translate }}</legend>
                        <mat-checkbox [formControl]="formGroup.controls.qualifiedVote">
                            {{ 'AgendaItemSettings.QualifiedVote' | translate }}
                        </mat-checkbox>
                        <br />
                        <mat-checkbox [formControl]="formGroup.controls.excludeManagementOrBoardOfDirectors">
                            {{ 'AgendaItemSettings.ExcludeManagementOrBoardOfDirectors' | translate }}
                        </mat-checkbox>
                    </fieldset>
                </div>
                <div class="col-6">
                    <fieldset>
                        <legend>{{ 'AgendaItemSettings.AsResult' | translate }}</legend>
                        <mat-checkbox [formControl]="formGroup.controls.capitalOnly">
                            {{ 'AgendaItemSettings.OnlyCapital' | translate }}
                        </mat-checkbox>
                        <br />
                        <mat-checkbox [formControl]="formGroup.controls.submittedVotesOnly">
                            {{ 'AgendaItemSettings.OnlySubmittedVotes' | translate }}
                        </mat-checkbox>
                        <br />
                        <mat-checkbox [formControl]="formGroup.controls.onlyYesNoVotes">
                            {{ 'AgendaItemSettings.OnlyYesNoVotes' | translate }}
                        </mat-checkbox>
                    </fieldset>
                </div>
                <div class="col-12">
                    <fieldset>
                        <legend>{{ 'AgendaItemSettings.InstructionsForNewRequests' | translate }}</legend>
                        <mat-form-field class="w-100">
                            <mat-label>
                                {{ 'AgendaItemSettings.MotionBoardOfDirectors' | translate }}
                            </mat-label>
                            <mat-select disabled [value]="$safeNavigationMigration(agendaItemSettings()?.boardOfDirectorsOptionsNumber)">
                                <mat-option [value]="VoteOptionEnum.Yes">
                                    {{ 'Voting.Yes' | translate }}
                                </mat-option>
                                <mat-option [value]="VoteOptionEnum.No">
                                    {{ 'Voting.No' | translate }}
                                </mat-option>
                                <mat-option [value]="VoteOptionEnum.Abstention">
                                    {{ 'Voting.Abstain' | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </fieldset>
                </div>
            </div>
        </form>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="onSave()" color="primary">{{ 'General.Save' | translate }}</button>
</mat-dialog-actions>
